module.exports = __webpack_public_path__ + "img/12.00e0f85f.webp";